import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import TextArea from '../../../../components/TextArea';
import messages from './messages';

import '../styles.css';

const CreditsNotAccepted = ({ onChange, initialValue }) => (
  <div styleName="transfer-credits-not-accepted">
    <p><FormattedMessage {...messages.transferCreditsNotAcceptedHint} /></p>
    <TextArea
      value={initialValue.value}
      onChange={onChange}
      data-cy="Premium-Hem-Transfer-CreditsNotAccepted-TextArea"
    />
  </div>
);

CreditsNotAccepted.propTypes = {
  onChange: PropTypes.func,
  initialValue: PropTypes.object,
};
export default CreditsNotAccepted;
